import { useLocation } from 'react-router-dom';

/* Renders children everywhere EXCEPT the given paths. Used for the global
   floating widgets (e.g. the theme toggle) that App.js mounts outside
   <Routes> — standalone campaign pages ship their own fixed visual
   identity and a light/dark switch floating over them is noise. */
export default function HideOnRoutes({ paths = [], children }) {
  const { pathname } = useLocation();
  const hidden = paths.some(
    (p) => pathname === p || pathname === `${p}/`
  );
  return hidden ? null : children;
}
